import { Card } from 'reactstrap';
import styled, { css } from 'styled-components';

const StyledCard = styled(Card)<{ $backgroundColor?: string }>`
  ${({ $backgroundColor }) => css`
    border: none;
    background-color: ${$backgroundColor};
    border-radius: 0 0 0.5rem 0.5rem;

    & > div {
      margin-top: 1rem;
    }
  `}
`;

export default StyledCard;
